import pick from 'lodash/pick';
import {Component} from 'panel';

import {Section} from 'common/components/items-menu/types';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {SelectTheme} from 'common/components/select/constants';

import {RangeSelection} from './types';
import {generateStepRanges} from './util';
import {template} from './template';
import css from './index.inline.styl';

export type StepRangeSelectorAttrs = {
  selected?: TODO;
  'num-steps'?: number;
  'row-label-type'?: string;
  label?: string;
  theme?: string;
  tooltip?: string;
  'disable-all-steps'?: boolean;
  disabled?: boolean;
};

export type SelectRangeEvent = CustomEvent<RangeSelection>;

// TODO deprecate this component. It should be moved to count-menu advanced selector
/** widget for selecting a range of two adjacent steps, or all steps. */
export class StepRangeSelector extends Component<UnknownObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      selected: {type: `json`, default: null},
      'num-steps': {type: `number`, default: 0},
      'row-label-type': {type: `string`, default: 0},
      label: {type: `string`, default: null, description: `Optional label before the menu.`},
      theme: {type: `string`, default: SelectTheme.Secondary, enum: Object.values(SelectTheme)},
      tooltip: `string`,
      'disable-all-steps': `boolean`,
      disabled: `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        contextPanelTransform: null,
      },
      helpers: {
        getOptions: (): Section[] => [
          {
            items: generateStepRanges({
              entry: this.attr(`selected`),
              steps: this.attr(`num-steps`),
              rowLabelType: this.attr(`row-label-type`),
              disableAllSteps: this.attr(`disable-all-steps`),
            }),
          },
        ],
        onChange: (ev) => {
          const item = pick(ev.detail.item.value, [`isEntireRange`, `range`]);
          this.dispatchEvent(new CustomEvent(`select`, {detail: item}));
        },
        contextPanelTransform: () => {
          return this.attr(`tooltip-data`);
        },
      },
    };
  }
}

export const StepRangeSelectorEl = defineAndMakeJsxFactory<{attrs: StepRangeSelectorAttrs}>(
  `mp-step-range-selector`,
  StepRangeSelector,
);
export const StepRangeSelectorReact = panel2react<{attrs: StepRangeSelectorAttrs}>(
  `mp-step-range-selector`,
  StepRangeSelector,
);
